import { createSlice } from '@reduxjs/toolkit';

const appCategoriesFilterSlice = createSlice({
    name: 'appCategoriesFilter',
    initialState: {
        isLoading: true,
        isError: false,
        error: false,
        getCategoryLevel: [],
        getCategoryType: [], // Added category type
    },
    reducers: {
        fetchCategoryLevelOption: (state, action) => {
            state.getCategoryLevel = action.payload;
            state.isLoading = false;
        },
        fetchCategoryLevelOptionError: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action?.payload?.response?.data?.message;
        },
        // Added reducers for getCategoryType
        fetchCategoryTypeOption: (state, action) => {
            state.getCategoryType = action.payload;
            state.isLoading = false;
        },
        fetchCategoryTypeOptionError: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action?.payload?.response?.data?.message;
        },
    },
});

export const { 
    fetchCategoryLevelOption, 
    fetchCategoryLevelOptionError,
    fetchCategoryTypeOption, 
    fetchCategoryTypeOptionError 
} = appCategoriesFilterSlice.actions;

export default appCategoriesFilterSlice.reducer;
